import {connect} from 'react-redux';

import {CalendarsPanelId} from '../../../../libs/shared/core/src/store/panels/panelStateBase';
import {makeMapDispatchToProps, makeMapStateToProps} from '../../../../srcCommon/helpers/reselectHelpers';
import {AppState} from '../../../store/appState';
import {updateSelectedSideFrameIdAction} from '../../../store/data/applications/selectedSideFrameIdActions';
import {makeGetVisualParticipants} from '../../../store/data/contacts/participantsSelectors';
import {getUserNamespace} from '../../../store/data/teammates/teammatesSelectors';
import {focusCalendarEventAction} from '../../../store/panels/calendars/calendarsPanelActions';
import {CalendarEventData} from '../../../store/panels/calendars/calendarsPanelSelectors';
import {SideCalendarEventViewer} from './sideCalendarEventViewer';

/*
 * Props.
 */

interface SideCalendarEventViewerContainerProps {
  panelId: CalendarsPanelId;
  calendarEventData: CalendarEventData;
  isCreatingFromOrphanEvent: boolean;
}

/*
 * Selectors.
 */

function getCalendarEvent(_state: AppState, props: SideCalendarEventViewerContainerProps) {
  return props.calendarEventData.calendarEvent;
}

/*
 * Redux.
 */

const mapStateToProps = makeMapStateToProps<SideCalendarEventViewerContainerProps>()(() => ({
  visualParticipants: makeGetVisualParticipants(getUserNamespace, getCalendarEvent),
}));

const mapDispatchToProps = makeMapDispatchToProps<SideCalendarEventViewerContainerProps>()(({panelId}) => ({
  onBackClick: () => focusCalendarEventAction(panelId, undefined),
  closeCalendarEventEditor: () =>
    // When saving a new event based on an orphan event, we automatically hide the calendar side-panel because
    // it's visually redundant with the calendar preview widget in P3.
    updateSelectedSideFrameIdAction(undefined, panelId),
}));

export const SideCalendarEventViewerContainer = connect(
  mapStateToProps,
  mapDispatchToProps,
)(SideCalendarEventViewer);
